import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Settings() {
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/tenant").then(({ data }) => setT(data)); }, []);
  if (!t) return <div className="p-8 text-muted-foreground text-sm">Caricamento…</div>;
  const set = (k) => (e) => setT({ ...t, [k]: e.target.value });

  const save = async () => {
    try { await api.put("/tenant", t); toast.success("Impostazioni salvate"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="p-8 max-w-2xl" data-testid="settings-page">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Profilo</div>
        <h1 className="text-3xl font-display font-bold mt-1">Impostazioni azienda</h1>
      </div>
      <div className="border border-border bg-white p-6 grid grid-cols-2 gap-4">
        <div className="col-span-2"><Label>Ragione sociale</Label><Input value={t.name || ""} onChange={set("name")} data-testid="s-name" /></div>
        <div><Label>P.IVA</Label><Input value={t.vat || ""} onChange={set("vat")} data-testid="s-vat" /></div>
        <div><Label>Telefono</Label><Input value={t.phone || ""} onChange={set("phone")} /></div>
        <div className="col-span-2"><Label>Indirizzo</Label><Input value={t.address || ""} onChange={set("address")} /></div>
        <div>
          <Label>Valuta</Label>
          <Select value={t.currency} onValueChange={(v) => setT({...t, currency: v})}>
            <SelectTrigger data-testid="s-currency"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="EUR">EUR €</SelectItem><SelectItem value="USD">USD $</SelectItem><SelectItem value="GBP">GBP £</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Sistema unità</Label>
          <Select value={t.unit_system} onValueChange={(v) => setT({...t, unit_system: v})}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="metric">Metrico (mm/kg)</SelectItem><SelectItem value="imperial">Imperiale (in/lb)</SelectItem></SelectContent>
          </Select>
        </div>
        <div>
          <Label>Lingua</Label>
          <Select value={t.language} onValueChange={(v) => setT({...t, language: v})}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="it">Italiano</SelectItem><SelectItem value="en">English</SelectItem></SelectContent>
          </Select>
        </div>
        <div><Label>IVA %</Label><Input type="number" value={t.vat_pct ?? 22} onChange={(e) => setT({...t, vat_pct: parseFloat(e.target.value)})} /></div>
        <div><Label>Email di contatto</Label><Input value={t.contact_email || ""} onChange={set("contact_email")} data-testid="s-email" /></div>
        <div className="col-span-2"><Label>URL logo (opzionale)</Label><Input value={t.logo_url || ""} onChange={set("logo_url")} placeholder="https://…" data-testid="s-logo" /></div>
        <div><Label>Validità standard (giorni)</Label><Input type="number" value={t.default_validity_days ?? 30} onChange={(e) => setT({...t, default_validity_days: parseInt(e.target.value) || 30})} /></div>
        <div><Label>Termini di pagamento</Label><Input value={t.default_payment_terms || ""} onChange={set("default_payment_terms")} placeholder="30 gg data fattura" /></div>
        <div className="col-span-2"><Label>Note standard del preventivo</Label>
          <textarea className="w-full border border-input px-3 py-2 text-sm" rows={3}
                    value={t.default_notes || ""}
                    onChange={(e) => setT({...t, default_notes: e.target.value})}
                    data-testid="s-notes"
                    placeholder="Prezzi IVA esclusa. Preventivo valido salvo verifiche tecniche." />
        </div>
        <Button onClick={save} className="col-span-2" data-testid="s-save">Salva</Button>
      </div>
    </div>
  );
}
